module.exports = __webpack_public_path__ + "img/micro.574a8622.svg";